<template>
    <div class="number-external-link">
        <div class="head">
            {{header.dataTitle}}
        </div>
        <div class="body-content">
            <div style="display: flex;height: 100%;overflow-y: auto;">
                <div style="flex: 1;margin-right: 16px;height: 100%;display: flex;flex-direction: column;overflow-y: auto;">
                    <div style="height:126px;background:#fff;padding: 14px 0 24px 20px;box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);">
                        <div style="color:rgba(44, 54, 74, 1);font-size: 13px;font-weight: bold;">进度</div>
                        <div style="padding-top:9px;display: flex;">
                            <div style="display: inline-block;width:200px;border-right: 1px solid rgba(229, 229, 229, 1);text-align: center;">
                                <img v-if="currentState=='暂存'" style="width:68px;" src="../../assets/img/state1.png" alt="">
                                <img v-if="currentState=='已提交'" style="width:68px;" src="../../assets/img/state2.png" alt="">
                                <img v-if="currentState=='处理中'" style="width:68px;" src="../../assets/img/state3.png" alt="">
                                <img v-if="currentState=='完成'" style="width:68px;" src="../../assets/img/state4.png" alt="">
                                <img v-if="currentState=='退回'" style="width:68px;" src="../../assets/img/state5.png" alt="">
                                <img v-if="currentState=='取消'" style="width:68px;" src="../../assets/img/state6.png" alt="">
                            </div>
                            <a-row style="flex:1;margin-left:100px;">
                                <a-col :span="6" style="display: flex;">
                                    <div style="display:inline-block;width:24px;">
                                        <div v-if="currentState!='暂存'" style="display:inline-block;width:24px;border:1px dotted #000;border-radius: 12px;text-align: center;line-height:22px;height: 24px;">
                                            <img style="width:16px;" src="../../assets/img/gou-000.svg" alt="">
                                        </div>
                                        <div v-if="currentState=='暂存'" style="display:inline-block;width:24px;border-radius: 12px;text-align: center;line-height:22px;height: 24px;background:#3ADCFF">
                                            <img style="width:16px;" src="../../assets/img/gou-fff.svg" alt="">
                                        </div>
                                        <div style="color:rgba(0, 0, 0, 1);font-size:12px;margin-top:10px;">暂存</div>
                                    </div>
                                    <div style="flex:1;padding:12px">
                                        <div style="height:2px;background:#9eacc4;"></div>
                                    </div>
                                </a-col>
                                <a-col :span="6" style="display: flex;">
                                    <div style="display:inline-block;width:36px;">
                                        <div v-if="currentState!='已提交'" style="display:inline-block;width:24px;border:1px dotted #000;border-radius: 12px;text-align: center;line-height:22px;height: 24px;margin-left:6px;">
                                            <img style="width:16px;" src="../../assets/img/gou-000.svg" alt="">
                                        </div>
                                        <div v-if="currentState=='已提交'" style="display:inline-block;width:24px;border-radius: 12px;text-align: center;line-height:22px;height: 24px;margin-left:6px;background:#3ADCFF">
                                            <img style="width:16px;" src="../../assets/img/gou-fff.svg" alt="">
                                        </div>
                                        <div style="color:rgba(0, 0, 0, 1);font-size:12px;margin-top:10px;">已提交</div>
                                    </div>
                                    <div style="flex:1;padding:12px">
                                        <div style="height:2px;background:#9eacc4;"></div>
                                    </div>
                                </a-col>
                                <a-col :span="6" style="display: flex;">
                                    <div style="display:inline-block;width:36px;">
                                        <div v-if="currentState!='处理中'" style="display:inline-block;width:24px;border:1px dotted #000;border-radius: 12px;text-align: center;line-height:22px;height: 24px;margin-left:6px;">
                                            <img style="width:16px;" src="../../assets/img/gou-000.svg" alt="">
                                        </div>
                                        <div v-if="currentState=='处理中'" style="display:inline-block;width:24px;border-radius: 12px;text-align: center;line-height:22px;height: 24px;margin-left:6px;background:#3ADCFF">
                                            <img style="width:16px;" src="../../assets/img/gou-fff.svg" alt="">
                                        </div>
                                        <div style="color:rgba(0, 0, 0, 1);font-size:12px;margin-top:10px;">处理中</div>
                                    </div>
                                    <div style="flex:1;padding:12px">
                                        <div style="height:2px;background:#9eacc4;"></div>
                                    </div>
                                </a-col>
                                <a-col :span="6">
                                    <div style="display:inline-block;width:24px;">
                                        <div v-if="currentState!='完成'" style="display:inline-block;width:24px;border:1px dotted #000;border-radius: 12px;text-align: center;line-height:22px;height: 24px;">
                                            <img style="width:16px;" src="../../assets/img/gou-000.svg" alt="">
                                        </div>
                                        <div v-if="currentState=='完成'" style="display:inline-block;width:24px;border-radius: 12px;text-align: center;line-height:22px;height: 24px;background:#3ADCFF">
                                            <img style="width:16px;" src="../../assets/img/gou-fff.svg" alt="">
                                        </div>

                                        <div style="color:rgba(0, 0, 0, 1);font-size:12px;margin-top:10px;">完成</div>
                                    </div>
                                </a-col>
                            </a-row>
                        </div>
                    </div>
                    <div style="flex:1;overflow-y: auto;">
                        <div style="background:#fff;padding: 14px 20px 24px 20px;margin-top:16px;box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);">
                            <div style="color:rgba(44, 54, 74, 1);font-size: 13px;font-weight: bold;">基本信息</div>
                            <a-row style="margin-top:22px;">
                                <a-col :span="6" style="display: flex;">
                                    <div style="width:36px;">
                                        <!-- <div style="display: inline-block;width:36px;height:36px;border-radius:18px;background:rgba(58, 220, 255, 1);color:#fff;font-size:13px;text-align: center;line-height:36px;">张三</div> -->
                                        <img style="display: inline-block;width:36px;height:36px;border-radius:18px;" :src="header.createAvatar" alt="">
                                    </div>
                                    <div style="flex:1;margin-left:12px;">
                                        <div style="color:rgba(18, 18, 18, 1);font-size:13px;">{{header.createBy}}</div>
                                        <div style="color:rgba(158, 172, 196, 1);font-size:11px;margin-top:3px;">创建人</div>
                                    </div>
                                </a-col>
                                <a-col :span="6" style="display: flex;">
                                    <div style="width:36px;">
                                        <!-- <div style="display: inline-block;width:36px;height:36px;border-radius:18px;background:rgba(78, 138, 250, 1);color:#fff;font-size:13px;text-align: center;line-height:36px;">张三</div> -->
                                        <img style="display: inline-block;width:36px;height:36px;border-radius:18px;" :src="header.ownerAvatar" alt="">
                                    </div>
                                    <div style="flex:1;margin-left:12px;">
                                        <div style="color:rgba(18, 18, 18, 1);font-size:13px;">{{header.owner}}</div>
                                        <div style="color:rgba(158, 172, 196, 1);font-size:11px;margin-top:3px;">负责人</div>
                                    </div>
                                </a-col>
                                <a-col :span="6" style="display: flex;">
                                    <div style="width:36px;">
                                        <div style="display: inline-block;width:36px;height:36px;border-radius:18px;background:#fff;text-align: center;line-height:36px;border:1px dotted rgba(158, 172, 196, 0.7)">
                                            <img src="../../assets/img/creat-time.svg" style="width:20px;" alt="">
                                        </div>
                                    </div>
                                    <div style="flex:1;margin-left:12px;">
                                        <div style="color:rgba(18, 18, 18, 1);font-size:13px;">{{ header.createTime }}</div>
                                        <div style="color:rgba(158, 172, 196, 1);font-size:11px;margin-top:3px;">创建时间</div>
                                    </div>
                                </a-col>
                                <a-col :span="6" style="display: flex;">
                                    <div style="width:36px;">
                                        <div style="display: inline-block;width:36px;height:36px;border-radius:18px;background:#fff;text-align: center;line-height:36px;border:1px dotted rgba(158, 172, 196, 0.7)">
                                            <img src="../../assets/img/creat-time.svg" style="width:20px;" alt="">
                                        </div>
                                    </div>
                                    <div style="flex:1;margin-left:12px;">
                                        <div style="color:rgba(18, 18, 18, 1);font-size:13px;">{{ header.updateTime }}</div>
                                        <div style="color:rgba(158, 172, 196, 1);font-size:11px;margin-top:3px;">修改时间</div>
                                    </div>
                                </a-col>
                            </a-row>
                            <div style="height: 1px;background:rgba(229, 229, 229, 1);margin:24px 0 20px;"></div>
                            <a-row class="tab-content" style="margin-top:20px;">
                                    <div v-for="(item, index) in fieldList" :key='index'>
                                        <div v-if="index!=0&&index!=1">
                                            <a-col :span="12" v-if="item.type=='SHORT_TEXT'">
                                                <div>
                                                    <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                        <a-icon type="font-size" />
                                                        <span style="margin-left:4px;">{{item.name}}：</span>
                                                    </div>
                                                    <div style="color:rgba(18, 18, 18, 1);margin-top:8px;">{{ item.value }}</div>
                                                </div>
                                            </a-col>
                                            <a-col :span="12" v-if="item.type=='URL'">
                                                <div>
                                                    <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                        <a-icon type="font-size" />
                                                        <span style="margin-left:4px;">{{item.name}}：</span>
                                                    </div>
                                                    <div style="color:rgba(18, 18, 18, 1);margin-top:8px;">{{ item.value }}</div>
                                                </div>
                                            </a-col>
                                            <a-col :span="12" v-if="item.type=='COMMODITY_SPECIFICATIONS'">
                                                <div>
                                                    <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                        <a-icon type="font-size" />
                                                        <span style="margin-left:4px;">{{item.name}}：</span>
                                                    </div>
                                                    <div style="color:rgba(18, 18, 18, 1);margin-top:8px;">
                                                        <span>{{item.value.length>20?item.value.substr(0,20)+'...':item.value}}</span>
                                                    </div>
                                                </div>
                                            </a-col>
                                            <a-col :span="12" v-if="item.type=='INTERFACE'||item.type=='USER_MONEY'">
                                                <div>
                                                    <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                        <a-icon type="font-size" />
                                                        <span style="margin-left:4px;">{{item.name}}：</span>
                                                    </div>
                                                    <div style="color:rgba(18, 18, 18, 1);margin-top:8px;">{{item.value}}</div>
                                                </div>
                                            </a-col>
                                            <a-col :span="12" v-if="item.type=='USER_CERTIFICATION'">
                                                <div>
                                                    <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                        <a-icon type="font-size" />
                                                        <span style="margin-left:4px;">{{item.name}}：</span>
                                                    </div>
                                                    <div style="color:rgba(18, 18, 18, 1);margin-top:8px;">{{ item.value }}</div>
                                                </div>
                                            </a-col>
                                            <a-col :span="12" v-if="item.type=='IMAGE'">
                                                <div>
                                                    <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                        <a-icon type="font-size" />
                                                        <span style="margin-left:4px;">{{item.name}}：</span>
                                                    </div>
                                                    <div class="img-text">
                                                        <img @click="viewPic(item.value)" :src="item.value" alt="">
                                                    </div>
                                                </div>
                                            </a-col>
                                            <a-col :span="12" v-if="item.type=='NUMBER'||item.type=='NUMBER_MONEY'">
                                                <div>
                                                    <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                        <a-icon type="font-size" />
                                                        <span style="margin-left:4px;">{{item.name}}：</span>
                                                    </div>
                                                    <div style="color:rgba(18, 18, 18, 1);margin-top:8px;">{{ item.value }}</div>
                                                </div>
                                            </a-col>
                                            <a-col :span="12" v-if="item.type=='TIME_YYYYMMDD'">
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="font-size" />
                                                    <span style="margin-left:4px;">{{item.name}}：</span>
                                                </div>
                                                <div style="color:rgba(18, 18, 18, 1);margin-top:8px;">
                                                    <div>{{ item.value }}</div>
                                                </div>
                                            </a-col>
                                            <a-col :span="12" v-if="item.type=='TIME_YYYYMMDDHHMMSS'">
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="font-size" />
                                                    <span style="margin-left:4px;">{{item.name}}：</span>
                                                </div>
                                                <div style="color:rgba(18, 18, 18, 1);margin-top:8px;">
                                                    <div>{{ item.value }}</div>
                                                </div>
                                            </a-col>
                                            <a-col :span="12" v-if="item.type=='LABEL'">
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="font-size" />
                                                    <span style="margin-left:4px;">{{item.name}}：</span>
                                                </div>
                                                <div class="affair-tags">
                                                    <div style="display:inline-block;" v-for="(item1,index1) in item.value" :key='index1'>
                                                        <span class="selected-item" :style="{'background':item1.color}">
                                                            {{item1.name}}
                                                        </span>
                                                    </div>
                                                </div>
                                            </a-col>
                                            <a-col :span="12" v-if="item.type=='SELECT_SINGLE'||item.type=='SELECT_SINGLE_ROLE'">
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="font-size" />
                                                    <span style="margin-left:4px;">{{item.name}}：</span>
                                                </div>
                                                <div style="color:rgba(18, 18, 18, 1);margin-top:8px;">
                                                    <div>{{item.value}}</div>
                                                </div>
                                            </a-col>
                                            <a-col :span="12" v-if="item.type=='COMMODITY_USER'">
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="link" />
                                                    <span style="margin-left:4px;">客户账号数量</span>
                                                </div>
                                                <div style="color:rgba(18, 18, 18, 1);margin-top:8px;">
                                                    <span>{{item.value}}</span>
                                                </div>
                                            </a-col>
                                            <a-col :span="24" v-if="item.type=='LONG_TEXT'" class="col-textarea">
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="font-size" />
                                                    <span style="margin-left:4px;">{{item.name}}：</span>
                                                </div>
                                                <div style="color:rgba(18, 18, 18, 1);margin-top:8px;">{{ item.value }}</div>
                                            </a-col>
                                            <a-col :span="24" v-if="item.type=='COLLABORATOR'">
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="font-size" />
                                                    <span style="margin-left:4px;">协助人：</span>
                                                </div>
                                                <div style="clear: both;"></div>
                                                <div class="helper" style="color:#fff;font-size:12px;margin-top:12px;">
                                                    <div v-for="(item1,index1) in item.value" :key='index1' style="display:inline-block;float:left">
                                                        <div class="personal">
                                                            <span v-if="item1.avatar==''" class="personal-title" :title="item1.name">{{item1.name.substr(-2,2)}}</span>
                                                            <img :title="item1.name" v-if="item1.avatar!=''" class="personal-img" style="object-fit: cover" :src="item1.avatar" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                            </a-col>
                                            <a-col :span="24" v-if="item.type=='SUPERIOR'">
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="font-size" />
                                                    <span style="margin-left:4px;">上级：</span>
                                                </div>
                                                <div class="helper" style="color:#fff;font-size:12px;margin-top:12px;">
                                                    <div v-for="(item1,index1) in item.value" :key='index1' style="display:inline-block;float:left">
                                                        <div class="personal">
                                                            <span v-if="item1.avatar==''" class="personal-title" :title="item1.name">{{item1.name.substr(-2,2)}}</span>
                                                            <img :title="item1.name" v-if="item1.avatar!=''" class="personal-img" style="object-fit: cover" :src="item1.avatar" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                            </a-col>
                                            <a-col :span="24" v-if="item.type=='ASSOCIATED_SINGLE'||item.type=='ASSOCIATED_BUSINESS'">
                                                <div style="color:rgba(158, 172, 196, 1);font-size:13px">
                                                    <a-icon type="paper-clip" />
                                                    <span style="margin-left:4px;">{{item.name}}：</span>
                                                </div>
                                                <span style="color:rgba(18, 18, 18, 1);margin-top:8px;" v-html="item.value"></span>
                                                <!-- <a-button v-if='changeJurisdiction&&item.isEditable' @click="connectModular(item.id)" style="height:28px;margin-top:7px;line-height:26px;font-size:13px;" type="primary" ghost>
                                                    关联模块
                                                </a-button> -->
                                            </a-col>
                                        </div>
                                    </div>
                                </a-row>
                        </div>
                        <div style="background:#fff;padding: 14px 20px 24px 20px;margin-top:16px;box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);">
                            <div style="color:rgba(44, 54, 74, 1);font-size: 13px;font-weight: bold;margin-bottom:20px;">附件信息</div>
                            <a-row :gutter="16">
                                <a-col class="gutter-row"  :span="8" v-for="(item,index) in externalList" :key="index" style="margin-bottom:16px;">
                                    <div class="gutter-box" style="background: transparent;border: 0;">
                                        <div style="display: flex;height:68px;border:1px solid rgba(229, 231, 235, 1);padding:14px 16px 0 17px;">
                                            <img src="../../assets/img/file2.png" style="width:24px;height:24px;margin-top:6px;margin-right: 8px;" alt="">
                                            <div style="flex:1;">
                                                <div style="color:rgba(18, 18, 18, 1);font-size:13px;white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 160px;">{{item.originName}}</div>
                                                <div style="color:rgba(158, 172, 196, 1);font-size:11px;margin-top:2px;">上传时间：{{item.createTime}}</div>
                                            </div>
                                            <div style="display: inline-block;margin-top: 8px;">
                                                <img @click="downLoadFile(item.downloadUrl)" src="../../assets/img/download.svg" style="width:18px;cursor: pointer;" alt="">
                                                <span @click="downLoadFile(item.downloadUrl)" style="color:rgba(24, 144, 255, 1);font-size:13px;margin-left:4px;cursor: pointer">下载</span>
                                            </div>
                                        </div>
                                    </div>
                                </a-col>
                            </a-row>
                        </div>
                    </div>
                </div>
                <div class="affair-scroll" style="width: 680px;background: #fff;padding: 14px 20px 20px;box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);height: 100%;overflow-y: auto;">
                    <div style="position: fixed;right:40px;bottom:150px;">
                        <div @click="toTop" class="to-bottom" style="display:inline-block;width:40px;height:40px;box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.12);background:#fff;border-radius: 20px;text-align: center;cursor: pointer;line-height: 40px;;">
                            <img class="to-bottom-img" style="width:24px;transform: rotate(180deg);" src="../../assets/img/to-bottom.svg" alt="">
                            <div class="to-bottom-text" style="color:rgba(158, 172, 196, 1);font-size:11px;">到顶部</div>
                        </div>
                        <div></div>
                        <div @click="toBottom" class="to-top" style="display:inline-block;width:40px;height:40px;box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.12);background:#fff;border-radius: 20px;text-align: center;cursor: pointer;line-height: 40px;margin-top:12px;">
                            <img class="to-top-img" style="width:24px;" src="../../assets/img/to-bottom.svg" alt="">
                            <div class="to-top-text" style="color:rgba(158, 172, 196, 1);font-size:11px;">到底部</div>
                        </div>
                    </div>
                    <div class="comment-content">
                        <div class="comment-list" v-for="(item,index) in commentTree" :key='index'>
                            <div class="responce-content">
                                <div style="display: flex;min-height:68px;padding:16px 16px 0;background:rgba(158, 172, 196, 0.3);border-radius: 8px 8px 0 0;margin-bottom:16px;">
                                    <div style="flex:1">
                                        <div class="response-text" v-html="item.content"></div>
                                        <div class="name">
                                            <span>{{item.createTime}}</span>
                                        </div>
                                    </div>
                                    <div style="display: inline-block;width:40px;">
                                        <img v-if="item.avatar!=''&&item.avatar!=null" :src="item.avatar" alt="" style="object-fit: cover">
                                        <span class="username" v-if="item.commentBy!=null&&item.commentBy!=''&&(item.avatar==''||item.avatar==null)">
                                            {{(item.commentBy).substr(0, 1)}}
                                        </span>
                                        <span style="font-size:12px" v-if="item.commentBy==null||item.commentBy==''">
                                            已删用户
                                        </span>
                                    </div>
                                </div>
                                <div style="padding:0 16px">
                                    <div style="width:100%;clear:both;margin-bottom:8px;" v-for="(item1,index1) in item.children" :key='index1'>
                                        <div v-if="item1.isMyself==0" style="display:flex;max-width:680px;">
                                            <img v-if="item1.avatar!=''&&item1.avatar!=null" style="width:40px;height:40px;border-radius: 20px;margin-right:0px;object-fit: cover;" :src="item1.avatar" alt="">
                                            <span style="display: inline-block;width: 40px;height: 40px;border-radius: 20px;color: #fff;text-align: center;line-height: 40px;background: rgba(121, 72, 234, 0.6);font-size: 20px;margin-right: 0px;" v-if="item1.commentBy!=null&&item1.commentBy!=''&&(item1.avatar==''||item1.avatar==null)">
                                                {{(item1.commentBy).substr(0, 1)}}
                                            </span>
                                            <span style="display: inline-block;width: 40px;height: 40px;border-radius: 20px;color: #fff;text-align: center;line-height: 40px;background: rgba(121, 72, 234, 0.6);font-size: 20px;margin-right: 0px;" v-if="item1.commentBy==null||item1.commentBy==''">
                                                已删
                                            </span>

                                            <div style="flex:1;margin-left:8px;">
                                                <div style="padding:8px;background:#fff;border-radius:8px;word-break: break-all" v-html="item1.content"></div>
                                                <div style="color:rgba(158, 172, 196, 0.7);font-size:12px;margin-top:4px;">{{item1.createTime}}</div>
                                            </div>
                                        </div>
                                        <div v-if="item1.isMyself==1" style="display:flex;max-width:680px;float: right;">
                                            <div style="flex:1;margin-left:8px;">
                                                <div style="padding:8px;background:#fff;border-radius:8px;word-break: break-all" v-html="item1.content"></div>
                                                <div style="color:rgba(158, 172, 196, 0.7);font-size:12px;margin-top:4px;text-align:right">{{item1.createTime}}</div>
                                            </div>
                                        </div>
                                        <div style="clear:both"></div>
                                    </div>
                                </div>
                                
                            </div>
                            
                        </div>
                    </div>
                    <div v-if="commentTree.length==0">
                        <div style="text-align:center;padding-top: 80px;">
                            <img style="width:56px;" src="../../assets/img/no-data.png" alt="">
                        </div>
                        <div style="color:rgba(158, 172, 196, 0.7);font-size:12px;text-align:center;">暂无数据</div>
                    </div>
                </div>
            </div>
        </div>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="picModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <a-icon @click="cancelShowPic" type="close" />
                </div>
                <div class="pic-content">
                    <img :src="picUrl" alt="">
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='true' v-model.trim="imgModal" :closable='false' footer='' :width="'auto'" >
            <div style="text-align: center;position:relative">
                <a-icon @click="closeImgModal" style="position:absolute;right:12px;top:12px;color:000;font-size:16px;cursor: pointer;" type="close-circle" />
                <img :src="imgUrl" alt="">
            </div>
        </a-modal>
    </div>
</template>

<script>
    export default {
        name: 'Chat',
        data() {
            return {
                id: '',
                header: '',
                currentState: '',
                fieldList: '',
                commentTree: [],
                picUrl: '',
                picModal: false,
                externalList: [],
                imgModal: false,
                imgUrl: ''
            }   
        },
        methods: {
            queryDetail() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/module/detailExternal', 
                        params: {
                            id: this.id,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.header = response.data.data.header
                        this.fieldList = response.data.data.fieldList
                        this.commentTree = response.data.data.commentTree
                        for(let i = 0; i < this.fieldList.length; i++){
                            if(this.fieldList[i]['code'] == 'status'){
                                this.currentState = this.fieldList[i]['value']
                            }
                        }
                        let imgStr = `width:632px`
                        let imgStr2 = `width:200px`
                        for(let i = 0; i < this.commentTree.length; i++){
                            for(let j = 0; j < this.commentTree[i]['children'].length; j++){
                                this.commentTree[i]['children'][j]['content'] = this.commentTree[i]['children'][j]['content'].replace(imgStr, imgStr2)
                            }
                        }
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            viewPic(url) {
                this.picModal = true
                this.picUrl = url
            },
            cancelShowPic() {
                this.picModal = false
            },
            queryAttachment() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/attachment/externalList', 
                        params: {
                            dataId: this.id,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        // console.log(response.data.data)
                        this.externalList = response.data.data
                       
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            downLoadFile(url) {
                window.open(url, '_blank');
            },
            handleDocumentClick(e) {
                if(e.target.className == 'comment-img'){
                    console.log(888)
                    this.imgModal = true
                    this.imgUrl = e.target.currentSrc
                }
            },
            closeImgModal() {
                this.imgModal = false
            },
            toBottom() {
                const modalContent = document.querySelector('.affair-scroll');
                modalContent.scrollTo({ top: modalContent.scrollHeight, behavior: 'smooth' });
            },
            toTop() {
                const modalContent = document.querySelector('.affair-scroll');
                modalContent.scrollTo({ top: 0, behavior: 'smooth' });
            },
        },
        mounted: function() {
            this.id = this.$route.query.id
            this.queryDetail()
            this.queryAttachment()
            document.addEventListener('click', this.handleDocumentClick);
        },
        beforeDestroy() {
            // 在组件销毁前移除事件监听，避免内存泄漏
            document.removeEventListener('click', this.handleDocumentClick);
        },
    }
</script>

<style scoped lang="less">
    .number-external-link{
        width: 100%;
        background: rgba(240, 242, 243, 1);
        padding-top: 56px;
        height: 100%;
        overflow-y: auto;
    }
    .head{
        height: 56px;
        background: #fff;
        line-height: 56px;
        padding-left: 30px;
        color: rgba(18, 18, 18, 1);
        font-size: 16px;
        font-weight: bold;
        position: fixed;
        width: 100%;
        left: 0;
        top: 0px;
    }
    .body-content{
        padding: 16px 30px 24px;
        height: 100%;
        overflow-y: auto;
    }
    .affairs-item{
        height: 70px;
    }
    .affairs-title{
        color: rgba(158, 172, 196, 1);
        font-size: 13px;
    }
    .affairs-content{
        color: rgba(18, 18, 18, 1);
        font-size: 13px;
        margin-top: 8px;
    }
    .comment-content{
        padding:0 0 21px 0;
        .comment-list{
            // display: flex;
            margin-bottom: 24px;
            background:rgba(158, 172, 196, 0.1);
            border-radius: 8px;
            // padding: 16px 16px 0 16px;
            img{
                width: 40px;
                height: 40px;
                margin-right: 16px;
                border-radius: 8px;
            }
            .responce-content{
                // border-bottom: 1px solid rgba(229, 229, 229, 1);
                padding-bottom: 16px;
                border-radius: 8px;
                // flex: 1;
                .name{
                    color: rgba(158, 172, 196, 1);
                    font-size: 12px;
                    span{
                        margin-right:10px;
                    }
                    margin-bottom: 0px;
                }
                .response-text{
                    color: rgba(18, 18, 18, 1);
                    font-size: 14px;
                    // margin-bottom: 14px;
                    font-weight:bold;
                    word-break: break-all;
                }
                .comment-operate{
                    span{
                        cursor: pointer;
                        color: rgba(121, 136, 155, 1);
                        font-size: 12px;
                    }
                }
                .response-to{
                    margin-top: 8px;
                    padding: 16px;
                    background: rgba(247, 247, 247, 1);
                    .name1{
                        color: rgba(121, 136, 155, 1);
                        font-size: 12px;
                    }
                    .name2{
                        color: rgba(121, 136, 155, 1);
                        font-size: 12px;
                    }
                    .res{
                        color: rgba(80, 80, 80, 1);
                    }
                    .res-text{
                        color: rgba(80, 80, 80, 1);
                        font-size: 12px;
                        word-break: break-all;
                    }
                    .time{
                        color: rgba(153, 153, 153, 1);
                        font-size: 12px;
                        float: right;
                    }
                }
            }
            .username{
                display: inline-block;
                width: 40px;
                height: 40px;
                border-radius: 20px;
                color: #fff;
                text-align: center;
                line-height: 40px;
                background: rgba(121, 72, 234, 0.6);
                font-size: 20px;
                float: left;
                margin-right: 16px;
            }
        }
    }
    .tab-content{
        .ant-col{
            padding-right: 24px;
            height: 60px;
            margin-bottom: 20px;
        }
        .col-textarea{
            height: 110px;
        }
        .edit-input{
            border: 1px solid #fff;
            margin-top: 8px;
            color: rgba(18, 18, 18, 1);
        }
        .show-text{
            border: 1px solid #fff;
            margin-top: 8px;
            color: rgba(18, 18, 18, 1);
            button{
                height: 23px;
                line-height: 20px;
                float: right;
                font-size: 12px;
                color: rgba(18, 18, 18, 1);
            }
            button:hover{
                border: 1px solid #d9d9d9;
            }
        }
        .img-text{
            margin-top: 8px;
            img{
                height: 32px;
                cursor: pointer;
            }
        }
        .edit-input:hover{
            border: 1px solid rgba(158, 172, 196, 0.3);
        }
        .end-date{
            height: 34px;
            line-height: 34px;
            .date-picker{
                display: none
            }
        }
        .related-business{
            margin-top: 8px;
            position: relative;
            .related-text{
                font-size: 13px;
                padding-top: 6px;
                padding-left: 12px;
                height: 24px;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                z-index: 100;
                background: #fff;
            }
            .related-selected{
                width: 100%;
                border: none;
                height: 100%;
            }
        }
    }
    .tab-detail{
        height: 60px;
        border-bottom: 1px solid rgba(229, 229, 229, 1);
        clear: both;
        .tab-title{
            color: rgba(18, 18, 18, 1);
            font-size: 13px;
            padding-top: 22px;
            display: inline-block;
            float: left;
            width: 480px;
            overflow: hidden;
            height: 42px;
        }
        .tab-label{
            margin-left: 12px;
            width: 225px;
            overflow: hidden;
            display: inline-block;
            margin-top: 18px;
            height: 28px;
            span{
                float: left;
            }
        }
        .tab-owner{
            float: right;
            margin-top: 17px;
            display: inline-block;
            width: 28px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            border-radius: 14px;
            background: rgba(35, 218, 119, 1);
            color: #fff;
            font-size: 12px;
        }
        .tab-img{
            float: right;
            width: 28px;
            margin-top: 17px;
            border-radius: 14px;
        }
        .tab-createtime{
            float: right;
            margin-right: 8px;
            margin-top: 20px;
            color: rgba(158, 172, 196, 1);
            font-size: 13px;
            display: inline-block;
            width: 118px;
        }
    }
    .add-new-data-modal{
        .add-title{
            padding: 20px 20px 14px 24px;
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .add-data{
            border-top: 1px solid rgba(229, 229, 229, 1);
            padding: 16px 24px 24px 24px;
            i{
                color: rgba(255, 170, 0, 1);
                font-size: 20px;
                margin-right: 20px;
            }
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 16px;
            }
        }
        .btn-group{
            padding: 0 20px 20px 0;
            height: 48px;
            div{
                float: right;
            }
            button{
                display: inline-block;
                width: 64px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
        .pic-content{
            text-align: center;
            img{
                width: 200px;
            }
        }
    }
    .personal-img{
        width: 32px;
        height: 32px;
        border-radius: 16px;
        // position: absolute;
        // left: 0px;
        // top: 0px;
    }
    .affair-tags{
            .selected-item{
                height: 28px;
                line-height: 28px;
                display: inline-block;
                padding: 0 12px;
                margin-right: 12px;
                // background: rgba(255, 195, 0, 1);
                color: #fff;
                font-size: 13px;
                cursor: pointer;
                margin-top: 7px;
                i{
                    font-size: 12px;
                    margin-left: 4px;
                    display: none;
                }
            }
        }
        .helper{
            .personal{
                display: inline-block;
                width: 32px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                color: #fff;
                font-size: 12px;
                border-radius: 16px;
                margin-right: 12px;
                background: rgba(58, 220, 255, 1);
                position: relative;
                span.personal-edit{
                    display: inline-block;
                    width: 12px;
                    height: 12px;
                    position: absolute;
                    top:-2px;
                    right: -1px;
                    background: #9EACC4;
                    color: #fff;
                    border-radius: 6px;
                    color: #fff;
                    line-height: 0px;
                    display: none;
                }
                .personal-img{
                    width: 32px;
                    border-radius: 16px;
                    position: absolute;
                    height: 32px;
                    left: 0px;
                    top: 0px;
                }
            }
            .personal:hover{
                cursor: default;
                span.personal-edit{
                    display: inline-block;
                    cursor: pointer;
                }
            }
            .personal-add{
                display: inline-block;
                width: 32px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                color: rgba(158, 172, 196, 1);
                font-size: 12px;
                border-radius: 16px;
                margin-right: 12px;
                border: 1px dashed rgba(158, 172, 196, 1);
                cursor: pointer;
            }
            .person-box{
                width: 280px;
                height: 400px;
                box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.12);
                position: absolute;
                bottom: -410px;
                left: 0px;
                background: #fff;
                z-index: 100;
                padding: 16px 0;
                display: flex;
                flex-direction: column;
                .person-box-tab{
                    height: 38px;
                    border-bottom: 1px solid rgba(229, 229, 229, 1);
                    line-height: 26px;
                    padding-left: 14px;
                    span{
                        display: inline-block;
                        // height: 38px;
                        color: rgba(158, 172, 196, 1);
                        font-size: 13px;
                        margin-right: 40px;
                        cursor: pointer;
                        margin-top:10px;
                    }
                    span.active{
                        border-bottom: 3px solid rgba(58, 220, 255, 1);
                        color: rgba(58, 220, 255, 1);
                    }
                }
                .user-provider-box{
                    flex: 1;
                    padding: 8px 0;
                    overflow-y: auto;
                    .user-box{
                        ul{
                            li{
                                height: 44px;
                                padding: 10px 20px 0;
                                cursor: pointer;
                                span:nth-child(1){
                                    display: inline-block;
                                    width: 24px;
                                    height: 24px;
                                    color: #fff;
                                    line-height: 24px;
                                    text-align: center;
                                    font-size: 12px;
                                    margin-right: 8px;
                                    border-radius: 12px;
                                    background: rgba(58, 220, 255, 1);
                                }
                                span:nth-child(2){
                                    color: rgba(18, 18, 18, 1);
                                    font-size: 13px;
                                }
                                i{
                                    float: right;
                                    color: rgba(58, 220, 255, 1);
                                    font-size: 16px;
                                    margin-top: 6px;
                                    
                                }
                            }
                            li:hover{
                                background: rgba(240, 242, 243, 0.5);
                            }
                        }
                    }
                }
            }
        }
        .gutter-box {
            background: #00a0e9;
            padding: 0px;
        }
        .to-bottom{
            .to-bottom-text{
                display: none;
            }
        }
        .to-bottom:hover .to-bottom-text{
            display: inline-block;
        }
        .to-bottom:hover .to-bottom-img{
            display: none;
        }
        .to-top{
            .to-top-text{
                display: none;
            }
        }
        .to-top:hover .to-top-text{
            display: inline-block;
        }
        .to-top:hover .to-top-img{
            display: none;
        }
</style>